import React from 'react'
import LoadingCardView from './view'

const LoadingCard = ({ ...props }) => <LoadingCardView {...props} />

export default LoadingCard
